import { render, staticRenderFns } from "./SanmerEdit.vue?vue&type=template&id=46c89a6d"
import script from "./SanmerEdit.vue?vue&type=script&lang=js"
export * from "./SanmerEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports